
export const GetNotMatchingValues = (items1: string[], items2: string[]): string[] => {
    let rtn: string[] = [];
    items1.forEach(item => {
        if (!items2.includes(item)) {
            rtn.push(item);
        }
    });
    return rtn;
}

export const Sort = (items: any, isAscending: boolean = true, fieldName?: string, isFilterByNumber?: boolean): any => {
    if (isFilterByNumber) {
        if (isAscending) {
            if (fieldName) {
                return items.sort((a, b) => (parseFloat(a[fieldName]) < parseFloat(b[fieldName]) ? -1 : 1));
            } else {
                return items.sort((a, b) => (parseFloat(a) < parseFloat(b) ? -1 : 1));
            }
        } else {
            if (fieldName) {
                return items.sort((a, b) => (parseFloat(a[fieldName]) > parseFloat(b[fieldName]) ? -1 : 1));
            } else {
                return items.sort((a, b) => (parseFloat(a) > parseFloat(b) ? -1 : 1));
            }
        }
    } else {
        if (isAscending) {
            if (fieldName) {
                return items.sort((a, b) => (a[fieldName] < b[fieldName] ? -1 : 1));
            } else {
                return items.sort((a, b) => (a < b ? -1 : 1));
            }
        } else {
            if (fieldName) {
                return items.sort((a, b) => (a[fieldName] > b[fieldName] ? -1 : 1));
            } else {
                return items.sort((a, b) => (a > b ? -1 : 1));
            }
        }
    }
}


export const getDistinct = (arr: any): any => {
    let rtn: any;
    rtn = arr.filter((n, i) => arr.indexOf(n) === i);
    return rtn;
}

export const getDistinctNumber = (arr: number[]): number[] => {
    let rtn: number[] = [];
    rtn = arr.filter((n, i) => arr.indexOf(n) === i);
    return rtn;
}

export const getDistinctAsString = (arr: any): string[] => {
    let rtn: string[] = [];
    arr.forEach(x => {
        if (!rtn.includes(x.toString())) {
            rtn.push(x.toString());
        }
    });
    return rtn;
}

export const hasFutureOrTodayDate = (dates: string[]): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize to start of today

    return dates.some(dateStr => {
        const parsedDate = new Date(dateStr);
        parsedDate.setHours(0, 0, 0, 0); // normalize input date
        return parsedDate.getTime() >= today.getTime();
    });
}

export const AreArraysEqualByKeyAndValues = <T>(a: T[], b: T[], orderField: string = 'key'): boolean => {
    if (a.length !== b.length) return false;

    const normalize = (obj: any) =>
        JSON.stringify(
            Object.keys(obj)
                .sort()
                .reduce((acc: any, k) => {
                    acc[k] = obj[k];
                    return acc;
                }, {})
        );

    const map = new Map<string, string>();

    for (const item of a) {
        if (!item[orderField]) {
            throw new Error('Missing orderField in first array');
        }
        map.set(item[orderField], normalize(item));
    }

    for (const item of b) {
        if (!item[orderField]) {
            throw new Error('Missing orderField in second array');
        }

        const value = map.get(item[orderField]);
        if (!value) return false;
        if (value !== normalize(item)) return false;
    }

    return true;
};
